/**
 * LOS INTERRUPTORES DE LA APP, EN UN SOLO SITIO.
 *
 * La lista estaba dentro de la pantalla de Planes, que es donde nacieron (doc 16-08). Al
 * sacarlos a su propia pantalla de Ajustes (punto 64) la lista pasa a leerse desde dos
 * sitios -- Ajustes, que los enciende para TODOS, y «Mi modo pruebas», que los enciende
 * solo para tu cuenta -- así que vive aquí para que no puedan discrepar: si un día se
 * añade una pantalla nueva, aparece en los dos a la vez o no aparece en ninguno.
 *
 * Lo que guardan estas claves está en `db.app_settings`, y se tocan desde la app para
 * poder apagar una pantalla SIN desplegar.
 */
export const PANTALLAS_APP = [
    { clave: 'frase_del_dia', label: 'La frase del día en Inicio', ayuda: 'Muestra una frase del día en la portada de Inicio del cliente.' },
    // AQUÍ VIVÍA «Inicio nuevo» (`t1_inicio_nuevo`), y se quitó el 04-11: el Inicio nuevo,
    // su barra de abajo y el recorrido guiado los ve todo el mundo.
    { clave: 't2_suplementos', label: 'Suplementos del cliente', ayuda: 'La pantalla de suplementos del cliente.' },
    { clave: 't3_entreno', label: 'Entreno (rutina y registro)', ayuda: 'Hace visible al cliente la rutina y el registro de sus entrenos.' },
    { clave: 't4_cierre_nuevo', label: 'Cierre del día nuevo', ayuda: 'El nuevo cierre del día del cliente («¿cómo fue hoy?»).' },
    { clave: 't5_diario', label: 'El Diario', ayuda: 'El Diario, dentro de Seguimiento.' },
    { clave: 't6_evolucion', label: 'Evolución completa del cliente', ayuda: 'La Evolución completa del cliente: medidas y fotos.' },
    { clave: 't10_avisos_nuevos', label: 'Los avisos nuevos', ayuda: 'Los avisos nuevos del cliente (la campanita).' },
    // EL SILENCIO DEL LANZAMIENTO (Francisco, 22-09). Encendido, la campana de TODOS los
    // clientes sale vacía y sin número; lo pendiente del Inicio sigue. Se apaga con otro clic
    // y vuelve lo que hubiera: no borra nada.
    { clave: 'silencio_avisos', label: 'Silencio: apagar la campana a todos', ayuda: 'Mientras esté encendido, ningún cliente ve avisos en la campana ni el contador. Lo pendiente del Inicio sigue saliendo. Al apagarlo vuelven.' },
    // AQUÍ VIVÍA «Los avisos del reporte, por correo» (`correos_avisos`), y SE QUITÓ A
    // PROPÓSITO el 14-09, con Francisco delante: «oculta el interruptor».
    //
    // Los de esta lista encienden o apagan una pantalla y se deshacen con otro clic. Ese
    // mandaba correos de verdad a gente de verdad, y no hay forma de recogerlos: la
    // madrugada del 14-09 salieron 80 de golpe -- «Tu ciclo ha terminado», a gente que
    // había cancelado en abril y en julio -- porque estaba encendido contra la decisión del
    // 30-08. Estar al lado de los demás, a un clic, era el fallo.
    //
    // No se ha borrado nada: la llave sigue existiendo y se sigue leyendo igual, y el
    // servidor RECHAZA cambiarla también por la API (`NO_SE_TOCAN_DESDE_EL_PANEL`, en
    // `backend/routes/settings.py`), que si no esconderla sería decoración. El día que se
    // decida encenderla se hace a propósito desde la base.
];

//: El que manda correos de verdad. Se avisa aparte antes de encenderlo.
export const MANDA_CORREOS = 'correos_avisos';

export default PANTALLAS_APP;
